import React from "react";
import { Grid } from "@mui/material";
import DescriptionActivite from "../shared/DescriptionActivite";
import OutilTelemedecine from "../shared/OutilTelemedecine";
import DocumentsExiges from "../shared/DocumentsExiges";
import MethodesContactMonSisra from "../shared/MethodesContactMonSisra";
import ClotureAuto from "./ClotureAuto";
import Restrictions from "./restriction/Restrictions";
import DemandesAutourPatient from "../shared/DemandesAutourPatient";
import { FormulaireSollicitation } from "../shared/FormulaireSollicitation";
import LienTeleExpertise from "../shared/LienTeleExpertise";
import InformationsFacturation from "./InformationsFacturation";
import EnvoiSyntheseMSS from "./EnvoiSyntheseMSS";
import { useAppSelector } from "../../store";

export function Expert() {
	const { preferences, useMonSisra } = useAppSelector((s) => s.expertise);

	const components = React.useMemo(() => {
		const elements = [];
		if (preferences?.statutDansAnnuaire) {
			elements.push(<LienTeleExpertise />, <DescriptionActivite />, <OutilTelemedecine />);

			if (useMonSisra) {
				elements.push(
					<DocumentsExiges />,
					<MethodesContactMonSisra />
				);

				if (preferences.msContactTeleExpertiseOnly) {
					elements.push(<Restrictions key={preferences.idTechPsExpert} />);
				}

				elements.push(
					<EnvoiSyntheseMSS />,
					<ClotureAuto />,
					<DemandesAutourPatient />
				);

				if (preferences?.centragePatient) {
					elements.push(<FormulaireSollicitation />, <InformationsFacturation />);
				}
			}
		}

		return elements;
	}, [preferences, useMonSisra]);

	return (
		<Grid container item sx={{ height: "100%" }} direction={"column"} spacing={2}>
			{components.map((comp, i) => (
				<Grid key={i} item>
					{comp}
				</Grid>
			))}
		</Grid>
	);
}
